<template>
  <div>
    <div v-if="this.data.landing">
      <v-container>
        <v-layout row>
          <v-flex
            md10
            offset-md0
            lg8
            offset-lg1
            xl7
            offset-xl2
          >
            <h1 :class="this.ÜberschriftSize">{{ Überschrift }}</h1>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container v-if="this.data.landing.wizard">
        <v-layout>
          <v-flex
            md12
            offset-md0
            lg10
            offset-lg1
            xl8
            offset-xl2
          >

            <anfragen-wizard
              :landing="this.data.landing"
              :stadt="this.data.stadt"
              :staedte="this.data.staedte"
              @call-back="callback()"
            ></anfragen-wizard>

          </v-flex>
        </v-layout>
      </v-container>
      <!-- <v-btn @click="scrollrunter()">scroll</v-btn> -->
      <!-- <v-container
        v-if="this.data.meta"
        class="mb-0"
        xstyle="border: 1px solid red;"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            md12
            lg10
            offset-lg1
            xl8
            offset-xl2
          >
            <v-layout
              align-center
              justify-space-between
              row
              wrap
              class="mb-3"
              v-if="this.data.meta.total > 0"
            >
              <div>
                <h2
                  class="headline"
                  id="landinghead"
                >
                  <strong>{{ this.data.meta.total }}</strong> Innungsfachbetriebe gefunden
                </h2>
              </div>
              <div
                class="headline"
                v-if="this.data.meta.last_page > 1"
              >
                <span v-if="ComputedPage">Seite {{ ComputedPage }} von {{ this.data.meta.last_page }}</span>
              </div>
            </v-layout>
          </v-flex>
          <v-flex
            md12
            offset-md0
            lg10
            offset-lg1
            xl8
            offset-xl2
            v-if="this.data.meta.total > 0"
          >
            <v-btn
              color="accent"
              :large="!$vuetify.breakpoint.xsOnly"
              @click="vuexBetriebe()"
              :loading="busy"
            >
              <v-icon left>map</v-icon>Auf Karte zeigen
            </v-btn>
          </v-flex>

        </v-layout>
      </v-container> -->
<!-- 
      <div v-if="this.data.meta">
        <v-container
          fluid
          grid-list-lg
          v-if="this.data.meta.total > 0"
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              sm6
              md4
              lg3
              v-for="betrieb in this.data.meta.data"
              :key="'betriebkey' + betrieb.id"
            >
              <landing-betrieb :betrieb="betrieb"></landing-betrieb>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container v-else>
          <v-layout class="mb-3">
            <v-flex
              offset-md2
              md8
            >
              <h4
                class="headline"
                id="landinghead"
              >Leider keine passenden Betriebe im gewählten Gebiet gefunden.
                <br>
                <br>Wir tragen kontinuierlich weitere Innungsfachbetriebe ein, versuchen Sie es bitte später nochmal.
              </h4>
            </v-flex>
          </v-layout>
        </v-container>
      </div> -->
      <!-- <div v-if="this.data.meta">
        <v-container>
          <v-layout>
            <v-flex xs12>
              <div
                class="text-xs-center"
                v-if="this.data.meta.last_page > 1"
              >
                <v-pagination
                  v-model="ComputedPage"
                  :length="this.data.meta.last_page"
                  :total-visible="$vuetify.breakpoint.xsOnly ? 5 : 10"
                  @input="onPageChange()"
                ></v-pagination>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div> -->
      <!-- <div v-if="this.data.innungen">
        <v-container
          v-if="this.data.innungen.length > 0"
          grid-list-xl
        >
          <v-layout row>
            <v-flex
              md8
              offset-md2
            >
              <h4 class="title mb-3">Verknüpfte Innungen im Bereich {{ this.data.stadt.name }} mit Radius {{ this.data.stadt.radius }} km</h4>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            align-center
            justify-center
          >
            <v-flex
              v-for="innung in this.data.innungen"
              :key="'innungkey' + innung.id"
              lg2
              md3
              sm4
              xs6
            >
              <v-hover>
                <v-card
                  tile
                  slot-scope="{ hover }"
                  :class="`pt-3 elevation-${hover ? 3 : 1}`"
                  :to="{name: 'Innung', params: { slug: innung.slug }}"
                >
                  <span v-if="innung.logo">
                    <v-img
                      :src="innung.logo"
                      class="mx-1"
                      contain
                      max-height="100"
                    ></v-img>
                  </span>
                  <v-card-title class="subheading text-xs-center justify-center">{{ innung.name }}</v-card-title>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </div> -->
      <!-- <v-container>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            md6
            offset-md0
            lg6
            offset-lg1
            xl5
            offset-xl2
            class="subheading landingtext"
          >
            <span v-if="this.data.staedte">
              <h4 class="title ml-4">Bitte wählen Sie Ihre Stadt</h4>
              <landing-sprung :staedte="this.data.staedte"></landing-sprung>
            </span>
            <span
              v-html="this.data.landing.text"
              class="landingtext"
            ></span>

            <v-container
              v-if="this.data.landing.leistungen.length > 0"
              grid-list-lg
            >
              <v-layout>
                <v-flex xs12>
                  <h4 class="title mb-3">Verknüpfte Leistungen</h4>
                  <v-layout
                    row
                    wrap
                  >
                    <v-flex
                      v-for="leistung in this.data.landing.leistungen"
                      :key="'leistungkey' + leistung.id"
                      md6
                    >
                      <v-card
                        tile
                        class="elevation-1"
                      >
                        <v-card-title>
                          <h3 class="subheading">
                            <v-icon
                              left
                              small
                            >build </v-icon> {{ leistung.leistung }}
                          </h3>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>

          <v-flex
            md3
            offset-md1
            v-if="this.data.staedte"
            class="mt-3"
          >
            <stadt-button
              :staedte="this.data.staedte"
              :landing="this.data.landing"
            ></stadt-button>
          </v-flex>
        </v-layout>
      </v-container> -->

      <!-- <v-container v-if="this.data.landing.text2">
        <v-layout>
          <v-flex
            md8
            offset-md2
            class="landingtext"
          >
            <span
              v-html="this.data.landing.text2"
              class="landingtext"
            ></span>
          </v-flex>
        </v-layout>
      </v-container> -->
    </div>

    <!-- <v-container fluid class="text-xs-right" v-if="!this.data.staedte">
    <anfrage-start
        :landing="this.data.landing"
        :stadt="this.data.stadt"
      ></anfrage-start>
    </v-container> -->

    <!-- {{ metaDescriptionText }}
    <vue-json-pretty :data="this.data">
    </vue-json-pretty> -->
  </div>
</template>

<script>
import axios from 'axios'
import StadtButton from '~/components/landing/StadtButton.vue'
import LandingSprung from '~/components/landing/LandingSprung.vue'
import LandingBetrieb from '~/components/listing/ListingBetrieb.vue'
import ListingSave from '~/components/ListingSave.vue'

import AnfrageStart from '~/components/anfragen/AnfragenStart.vue'
import AnfragenWizard from '~/components/anfragen/AnfragenWizard.vue'

// import VueRouter from 'vue-router'

export default {
  data () {
    return {
      daten: [],
      page: 1,
      busy: false,
      last_page: 30,
      data: {
        landing: {
          name: '',
          leistungen: []
        },
        betriebe: []
      },
      title: '',
      landing: {
        text: '',
        name: '',
        anzeigekat: ''
      },

      index: null
    }
  },
  components: {
    StadtButton,
    ListingSave,
    LandingSprung,
    LandingBetrieb,
    AnfrageStart,
    AnfragenWizard
  },
  computed: {
    // erstellt Überschrift aus $route + Uppercase 1. Buchstabe
    Überschrift: function () {
      var text = this.data.landing.name
      if (this.$route.params.stadt) {
        if (this.data.stadt) {
          text = text + ' in ' + this.data.stadt.name
        } else {
          text =
            text +
            ' in ' +
            this.$route.params.stadt.charAt(0).toUpperCase() +
            this.$route.params.stadt.slice(1)
        }
      }
      return text
    },
    ÜberschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'display-1'
      } else {
        return 'display-3'
      }
    },
    metaLeistungenListe: function () {
      var string = JSON.stringify(
        this.data.landing.leistungen.map(item => item.leistung)
      ).replace(/[\[\]"]+/g, '')

      var length = 140
      string = string.substring(0, length)
      return string
    },
    metaDescriptionText: function () {
      if (this.data.landing.metatext) {
        return this.Überschrift + '. ' + this.data.landing.metatext
      } else {
        return this.Überschrift + '. ' + this.metaLeistungenListe
      }
    },
    ComputedPage: {
      get: function () {
        let computedPage = 1
        if (this.$route.params.page) {
          computedPage = this.$route.params.page
          computedPage = parseInt(computedPage)
        }
        return computedPage
      },
      set: function (newValue) {
        // console.log(newValue)
        this.page = newValue
        // return computedPage
      }
    }
  },
  created () {},

  beforeRouteEnter (to, from, next) {
    // ohne stadt
    axios
      .get('/api/v1/landing/', {
        params: {
          landing: to.params.landing,
          stadt: to.params.stadt,
          page: to.params.page
        }
      })
      .then(resp => {
        next(vm => (vm.data = resp.data))
      })
      .catch(error => {
        console.log(error)
        // if (error.response) {
        //   console.log('err response')
        //   console.log(error.response)
        // } else if (error.request) {
        //   console.log('request putt')
        // } else {
        //   console.log('Error', error.message)
        // }
        //  app.$router.push('/')
        console.log('versuche 404 push...')
        next({ name: '404' })
        // next('/404')
      })
  },
  beforeRouteUpdate (to, from, next) {
    axios
      .get('/api/v1/landing/', {
        params: {
          landing: to.params.landing,
          stadt: to.params.stadt,
          page: to.params.page
        }
      })
      .then(resp => {
        // this.data = null
        this.setData(resp.data)
        next()
        // next(vm => (vm.anzeige = resp.data))
      })
      .catch(error => {
        if (error.response.status === 404) {
          console.log('404 push')
          next({ name: '404' })
        }
        if (error.response) {
          console.log('err response')
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // console.log('request putt')
          //   console.log(error.request);
        } else {
          console.log('Error', error.message)
        }

        //  app.$router.push('/')
        next('/404')
      })
  },
  methods: {
    setData (data) {
      this.data = data
      // this.data = Object.freeze(data)
    },
    scrollrunter () {
      this.$vuetify.goTo('#landinghead', { offset: -100 })
    },
    onPageChange () {
      const context = this
      // console.log(context.page)
      // console.log(context.$route.params)
      this.$router.push({
        name: 'Landing',
        params: {
          landing: context.$route.params.landing,
          stadt: context.$route.params.stadt,
          page: context.page
        }
      })
    },
    async vuexBetriebe () {
      // busy löppt nicht im Moment
      this.busy = true
      const context = this

      var payload = {
        leistung: context.data.leistungen,
        standort: context.$route.params.stadt,
        suchbegriff: context.data.landing.name
      }
      await this.$store.dispatch('fetchBetriebe', payload)

      this.$router.push({
        name: 'lokal'
      })

      this.busy = false
      // this.$emit('busy', false)
    },
    callback () {
      console.log('called back')
    }
  },

  metaInfo () {
    return {
      title: this.Überschrift + ' - Seite ' + this.ComputedPage,
      meta: [{ name: 'description', content: this.metaDescriptionText }]
    }
  }
  // metaInfo () {
  //   if (this.Überschrift) {
  //     return { title: this.Überschrift }
  //   } else {
  //     return { title: ' ' }
  //   }
  // }
}
</script>

<style scoped>
.landingtext >>> ul li {
  margin: 1.3em;
}
</style>
